module.exports = __webpack_public_path__ + "wechat-static/img/banner1.01d72e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner1.png
// module id = GpJk
// module chunks = 1